import { createActions } from 'redux-actions';
import { 
	GET_QUESTIONS,
	SET_QUESTIONS,
} from '../constants/Actions';

export const { getQuestions } = createActions(GET_QUESTIONS);

export const { setQuestions } = createActions(SET_QUESTIONS);